<template>
    <div>
        <nav class="panel" v-for="item of orderInfo.items" v-bind:key="item.reference">
            <p class="panel-heading">
                Item: {{item.reference}}
            </p>
            <div class="panel-block">
                <div class="columns" style="width:100%">
                    <div class="column">
                        <table class="table table-mobile-card" style="width: 100%">
                            <tbody>
                                <tr v-if="item.reference">
                                    <td style="width: 200px;"><b>Reference</b></td>
                                    <td>{{item.reference}}</td>
                                </tr>
                                <tr v-if="item.name">
                                    <td><b>Product name</b></td>
                                    <td>{{item.name}}</td>
                                </tr>
                                <tr v-if="item.product_reference">
                                    <td><b>Product reference</b></td>
                                    <td>{{item.product_reference}}</td>
                                </tr>
                                <tr v-if="item.type === 'stock'">
                                  <td><b>Type</b></td>
                                  <td>stock</td>
                                </tr>
                                <tr v-if="item.count">
                                    <td><b>Count</b></td>
                                    <td>{{item.count}}</td>
                                </tr>
                                <tr v-if="item.shipping_option">
                                    <td><b>Shipping option</b></td>
                                    <td>{{item.shipping_option}}</td>
                                </tr>
                                <tr v-if="item.tracking">
                                    <td><b>Tracking</b></td>
                                    <td>{{item.tracking}}</td>
                                </tr>
                                <tr v-if="item.options && item.options.length > 0">
                                    <td><b>Options</b></td>
                                    <td>
                                        <p v-for="option of item.options" v-bind:key="option.note">– {{option.note}}: {{option.count}}</p>
                                    </td>
                                </tr>
                                <tr v-for="file of item.files" v-bind:key="file.type">
                                    <td width="150"><b>{{file.type | capitalize}} file </b></td>
                                    <td>
                                        <a :href="file.url" target="_blank">
                                            <b-icon pack="fas" icon="arrow-down" size="is-small"/> Download
                                        </a>
                                    </td>
                                    <td v-if="file.md5">MD5: {{file.md5}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
  props: {
    orderInfo: Object
  },

  data () {
    return {
    }
  },
  methods: {}
}
</script>
